module.exports = __webpack_public_path__ + "static/media/orange.ad8737e2.svg";